import styled from 'styled-components'
import { Box } from 'reflexbox'

const DropZoneContainer = styled(Box)`
  border: 2px dashed ${({isDragActive }) => !isDragActive ? 'var(--border-color)' : 'var(--purple-bnz)' };
  border-radius: 8px;
  padding: 1.6em 1em;
  color: var(--text-secondary);
  background-color: var(--dropzone-bg);
  opacity: ${({isDragActive }) => isDragActive ? .6 : 1 };
  margin-bottom: 1em;
  transition: border-color 0.3s ease, color 0.3s ease, background-color 0.3s ease;
  
  p {
    color: var(--text-color);
    transition: color 0.3s ease;
  }
`

export default DropZoneContainer
